<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active" v-on:click="goTo('/stats')">Estadísticas</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Cliente</a>
  </div>
  <h1 class="ui header">
    <img v-if="image_url" class="ui small image" :src="image_url">
    <img v-if="!image_url" class="ui small image" src="../../assets/name.png">
    <div class="content">Estadísticas {{client.toUpperCase()}}: {{year}} </div>
  </h1>
  <div class="rightButton">
    <a class="section" v-on:click="getStats(year-1)"><i class="big arrow alternate circle down icon"></i></a>
    <a class="section" v-on:click="getStats(year+1)"><i class="big arrow alternate circle up icon"></i></a>
  </div>
  <div class="ui tabular menu">
    <a class="item active" v-on:click="goTo('/stats/'+client)">
      Cliente
    </a>
    <a class="item" v-on:click="goTo('/stats-apms/'+client)">
      APMS
    </a>
  </div>
  <div v-if="!data" class="ui active centered inline loader"></div>
  <div v-if="data" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <chartjs-bar :option="myoption" :datalabel="mylabel" :labels="mylabels" :data="mydata" :bordercolor="'#00f9a9'" :backgroundcolor="'rgba(0,249,169,0.1)'"></chartjs-bar>
      </div>
    </div>
    <div class="row" style="text-align:center">
      <div class="column ">
        <div class="ui huge horizontal statistic">
          <div class="value">
            {{totala}}
          </div>
          <div class="label">{{client}}<br />PAQUETES RECOGIDOS EN<br />{{year}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'statsClient',
  props: ['client'],
  data() {
    return {
      image_url: null,
      data: null,
      year: null,
      mylabels: null,
      mydata: null,
      totala: null,
      mylabel: 'Paquetes recogidos',
      myoption: {
        onClick: (evt, item) => {
          this.selectMonth(item[0]._model.label)
        },
        onHover: function(e) {
          var point = this.getElementAtEvent(e);
          if (point.length) e.target.style.cursor = 'pointer'
          else e.target.style.cursor = 'default'
        }
      }
    }
  },
  created() {
    let year = new Date().getFullYear()
    this.getStats(year)
    this.getImages()
  },
  methods: {
    async getImages() {
      await hapiickApi().get('/v1/images/stats?admin_id='+JSON.parse(localStorage.admin).id)
      .then(request => {
        this.images = JSON.parse(JSON.stringify(request.data.data))
        let url = this.images.find((e) => {
          return (e.key === this.client)
        })
        if (url !== undefined) {
          this.image_url = url.url
        } else {
          this.image_ur = null
        }
      })
      .catch(() => console.log('error getting images'))
    },
    getStats(year) {
      this.data = null
      this.year = year
      let hoy = new Date();
      let current_year = hoy.getFullYear();
      this.last_month = 12;
      if (this.year == current_year) {
        this.last_month = hoy.getMonth() + 1;
      }
      hapiickApi().post('/v3/stats/years', {
          admin_id: JSON.parse(localStorage.admin).id,
          year: year,
          client: this.client
        })
        .then(request => this.updateStatistics(request))
        .catch((request) => console.log('error getting stats:' + request))
    },
    updateStatistics(req) {
      this.data = JSON.parse(JSON.stringify(req.data.data));
      let datuak = {...this.data.monthPicks};
      let hilabeteak = []
      let zerrenda = []
      let total=0
      //let ultimo_mes = Object.keys(datuak)[Object.keys(datuak).length-1];

      for (let i=1; i<=this.last_month; i++) {
        hilabeteak.push(this.$months[i-1]);
        if (datuak.hasOwnProperty(i)) {
          zerrenda.push(datuak[i]);
        } else {
          zerrenda.push(0);
        }
      }

      this.mylabels = hilabeteak;
      this.mydata = zerrenda;
      this.totala=zerrenda.reduce((a, b) => a + b);
    },
    selectMonth(month) {
      let m = Object.keys(this.$months).find(key => this.$months[key] === month);
      m++;
      this.goTo('/stats/' + this.client + '/' + this.year + '/' + m)
    },
    goTo(where) {
      this.$router.push(where)
    },
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Stats/statsClient.vue